"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _AccessAvatar = _interopRequireDefault(require("./AccessAvatar"));
var _AccessName = _interopRequireDefault(require("./AccessName"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function AccessesMenu(_ref) {
  var accesses = _ref.accesses,
    anchorRef = _ref.anchorRef,
    onClose = _ref.onClose;
  var context = (0, _react.useContext)(_core.AppContext);
  var changeAccess = function changeAccess(access) {
    return function () {
      var _a, _b;
      onClose();
      if (((_a = context.access) === null || _a === void 0 ? void 0 : _a.id) !== access.id) {
        context.onChangedAccess((_b = access.tenant) === null || _b === void 0 ? void 0 : _b.id);
      }
    };
  };
  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab' || event.key === 'Escape') {
      event.preventDefault();
      onClose();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.PopperMenu, {
    placement: "bottom",
    anchorRef: anchorRef,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuList, {
    autoFocusItem: true,
    id: "accesses-menu",
    sx: function sx(theme) {
      return {
        minWidth: theme.spacing(25)
      };
    },
    onKeyDown: handleListKeyDown
  }, accesses.map(function (access) {
    var _a, _b;
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: access.id,
      onClick: changeAccess(access),
      selected: ((_a = context.access) === null || _a === void 0 ? void 0 : _a.id) === access.id,
      component: "a",
      href: ((_b = access.tenant) === null || _b === void 0 ? void 0 : _b.id) ? "/t/".concat(access.tenant.id, "/") : '/'
    }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_AccessAvatar["default"], {
      access: access
    })), /*#__PURE__*/_react["default"].createElement(_AccessName["default"], {
      access: access
    }));
  })));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AccessesMenu);